<!-- <p>company works!</p> -->
<div class="main-outer company-list admin-customer-subscription">
    <app-header></app-header>
    <div class="municipality-accounts" [ngClass]="Menustatus ? 'show' : ''">
        <div class="municipality-accounts__sidebar doc-cabinet-menu-left">
            <h2 class="heading-secondery">Admin</h2>

            <ul class="dc-menu-list">
                <li class="dc-menu-item">
                    <a href="javascript:void(0);" routerLink="/company" routerLinkActive="active">Companies</a>
                </li>
                <li class="dc-menu-item">
                    <a href="javascript:void(0);" routerLink="/subscriptions"
                        routerLinkActive="active">Subscriptions</a>
                </li>
                <li class="dc-menu-item">
                    <a href="javascript:void(0);" routerLink="/batches" routerLinkActive="active">Batches</a>
                </li>
            </ul>

            <a href="javascript:void(0);" class="sidebar-menu" (click)="showMenu()">
                <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M0 1.40476C0 1.07008 0.132951 0.749111 0.369604 0.512457C0.606258 0.275804 0.927229 0.142853 1.26191 0.142853H16.4048C16.7395 0.142853 17.0605 0.275804 17.2971 0.512457C17.5338 0.749111 17.6667 1.07008 17.6667 1.40476C17.6667 1.73944 17.5338 2.06041 17.2971 2.29706C17.0605 2.53372 16.7395 2.66667 16.4048 2.66667H1.26191C0.927229 2.66667 0.606258 2.53372 0.369604 2.29706C0.132951 2.06041 0 1.73944 0 1.40476Z"
                        fill="white" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M7.57144 7.7143C7.57144 7.37962 7.70439 7.05865 7.94105 6.822C8.1777 6.58534 8.49867 6.45239 8.83335 6.45239H16.4048C16.7395 6.45239 17.0604 6.58534 17.2971 6.822C17.5338 7.05865 17.6667 7.37962 17.6667 7.7143C17.6667 8.04898 17.5338 8.36995 17.2971 8.6066C17.0604 8.84326 16.7395 8.97621 16.4048 8.97621H8.83335C8.49867 8.97621 8.1777 8.84326 7.94105 8.6066C7.70439 8.36995 7.57144 8.04898 7.57144 7.7143Z"
                        fill="white" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M0 14.0238C0 13.6892 0.132951 13.3682 0.369604 13.1315C0.606258 12.8949 0.927229 12.7619 1.26191 12.7619H16.4048C16.7395 12.7619 17.0605 12.8949 17.2971 13.1315C17.5338 13.3682 17.6667 13.6892 17.6667 14.0238C17.6667 14.3585 17.5338 14.6795 17.2971 14.9161C17.0605 15.1528 16.7395 15.2857 16.4048 15.2857H1.26191C0.927229 15.2857 0.606258 15.1528 0.369604 14.9161C0.132951 14.6795 0 14.3585 0 14.0238Z"
                        fill="white" />
                </svg>
            </a>
        </div>


        <div class="container">
            <div class="page-wrapper" [ngClass]="filterResposniveEvent ? 'active-sidebar' : ''">

                <div class="page-filter" *ngIf="!isCustomerAdmin">
                    <div class="page-filter-inner">
                        <div class="">
                            <a class="close-popup close-popup-filter" href="javascript:void(0);"
                                (click)="filterClickEvent()">
                                <svg width="19" height="19" viewBox="0 0 19 19" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M17.3104 1.67919L1.49018 17.4995" stroke="#4E4E4E" stroke-width="2" />
                                    <line x1="1.77569" y1="1.3107" x2="17.4143" y2="17.7099" stroke="#4E4E4E"
                                        stroke-width="2" />
                                </svg>
                            </a>
                            <h2>Filters</h2>

                            <div class="select-menu filter-group">
                                <label class="filter-lbl">Customer</label>
                                <p-dropdown class="select-dropdown" [options]="customerOptions" optionLabel="label"
                                    optionValue="value" [(ngModel)]="selectedCustomerId" [filter]="true"
                                    [showClear]="true" placeholder="Select"></p-dropdown>
                            </div>

                            <div class="select-menu filter-group">
                                <label class="filter-lbl">Status</label>
                                <p-dropdown class="select-dropdown" [options]="statusList" optionLabel="label"
                                    optionValue="value" [(ngModel)]="selectedStatus" [showClear]="true"
                                    placeholder="Select"></p-dropdown>
                            </div>

                            <div class="form-button-group">
                                <a class="btn-primary common-btn" (click)="applyFilters()">Apply</a>
                                <a [ngClass]="showClearFilter ? '' : 'active'" *ngIf="displayClearButton"
                                    class="btn-secondary" (click)="resetFilter()">Clear</a>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="page-wrapper-listing">

                    <div class="title-block">
                        <div class="title-block__left">
                            <h1>Subscriptions</h1>
                        <p>Scanning subscriptions for all companies. Open one to view usage or add a subscription period.</p>
                        </div>
                        
                        <div class="responsive-filter">
                            <a class="btn-primary add-buttons" href="javascript:void(0);"
                                style="white-space: nowrap; display: inline-flex; align-items: center; gap: 8px; margin-right: 12px;"
                                (click)="openNewSubscriptionDialog()">New Subscription</a>
                            <a href="javascript:void(0);" class="mobile-block" (click)="filterClickEvent()">
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20">
                                    <path fill="none" fill-rule="evenodd" stroke="#fff" stroke-linecap="round"
                                        stroke-linejoin="round" stroke-width="2" d="M20 0H0l8 9.46V16l4 2V9.46z"
                                        transform="translate(1 1)" />
                                </svg>
                            </a>
                            <div class="search-box search-component">
                                <input type="text" #searchBox class="search-box__input" placeholder="Search"
                                    [(ngModel)]="searchText" (input)="onSearchChange($any($event.target).value)" />
                                <a href="javascript:void(0);" class="search-box__btns"><svg width="15" height="15"
                                        viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M6.41471 12.8287C7.83796 12.8284 9.22019 12.352 10.3413 11.4753L13.8662 15L15 13.8663L11.4751 10.3416C12.3523 9.22039 12.8291 7.83791 12.8294 6.41437C12.8294 2.87765 9.95162 0 6.41471 0C2.8778 0 0 2.87765 0 6.41437C0 9.95109 2.8778 12.8287 6.41471 12.8287ZM6.41471 1.60359C9.068 1.60359 11.2257 3.76123 11.2257 6.41437C11.2257 9.06751 9.068 11.2251 6.41471 11.2251C3.76143 11.2251 1.60368 9.06751 1.60368 6.41437C1.60368 3.76123 3.76143 1.60359 6.41471 1.60359Z"
                                            fill="#434343" />
                                    </svg>
                                </a>
                            </div>

                            <div class="customer-sum" *ngIf="subscriptions?.length > 0">({{subscriptions?.length}}
                                of {{totalRecords}} Subscriptions)</div>
                        </div>
                    </div>

                    <div class="document-cabinet-list customers-list company-table">
                        <div class="column-frozen-table">
                            <p-table [value]="subscriptions" class="tables-frozen customers-list-table"
                                [rows]="pageSize" [virtualScroll]="true" [scrollable]="true"
                                [lazy]="true" [lazyLoadOnInit]="false" [totalRecords]="totalRecords"
                                (onLazyLoad)="onLazyLoad($event)" scrollHeight="500px">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th pSortableColumn="SubscriptionCode" style="min-width: 150px;">Subscription ID <span class="sorting-icon"></span></th>
                                        <th pSortableColumn="FullName">Company <span class="sorting-icon"></span></th>
                                        <th pSortableColumn="SubscriptionType">Subscription Type <span class="sorting-icon"></span></th>
                                        <th pSortableColumn="StartDate">Start <span class="sorting-icon"></span></th>
                                        <th pSortableColumn="EndDate">End <span class="sorting-icon"></span></th>
                                        <th pSortableColumn="SubscriptionVolume">Volume <span class="sorting-icon"></span></th>
                                        <th pSortableColumn="ConsumedVolume">Consumed <span class="sorting-icon"></span></th>
                                        <th pSortableColumn="RemainingVolume">Remaining <span class="sorting-icon"></span></th>
                                        <th pSortableColumn="UsagePercent">Usage <span class="sorting-icon"></span></th>
                                        <th pSortableColumn="Status">Status <span class="sorting-icon"></span></th>
                                        <th pSortableColumn="DateTimeCreated">Created On <span class="sorting-icon"></span></th>
                                        <th pSortableColumn="CreatedByName">Created By <span class="sorting-icon"></span></th>
                                        <th class="action-th">Action</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-subscription>
                                    <tr>
                                        <td style="min-width: 150px; white-space: nowrap; overflow: visible; text-overflow: clip;"><a class="org-name" href="javascript:void(0);"
                                                style="white-space: nowrap; overflow: visible; text-overflow: clip; display: inline-block; max-width: none;"
                                                (click)="goToCustomerSubscriptions(subscription)">{{ subscription.SubscriptionCode }}</a></td>
                                        <td>{{getCustomerName(subscription.CompanyId) }}</td>
                                        <td>{{ subscription.SubscriptionType }}</td>
                                        <td>{{ subscription.StartDate | date:'MMM d, y' }}</td>
                                        <td>{{ subscription.EndDate | date:'MMM d, y' }}</td>
                                        <td>{{ subscription.SubscriptionVolume | number }}</td>
                                        <td>{{ subscription.ConsumedVolume | number }}</td>
                                        <td>{{ subscription.RemainingVolume | number }}</td>
                                        <td>{{ (subscription.UsagePercent || 0) | number:'1.0-2' }}%</td>
                                        <td>
                                            <span
                                                [ngClass]="subscription.Status === 'Active' ? 'status status__active' : subscription.Status === 'Upcoming' ? 'status status__upcoming' : 'status status__expired'">
                                                {{ subscription.Status }}
                                            </span>
                                        </td>
                                        <td>{{ subscription.DateTimeCreated | date:'MMM d, y' }}</td>
                                        <td>{{ subscription.CreatedByName }}</td>
                                        <td>
                                            <div class="table-action">
                                                <a class="edits" href="javascript:void(0);" pTooltip="Edit"
                                                    tooltipPosition="top" (click)="openNewSubscriptionDialog(subscription)">
                                                    <svg width="19" height="18" viewBox="0 0 19 18" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M18.0886 0.863808C17.7995 0.589949 17.4564 0.372711 17.0787 0.224498C16.701 0.0762847 16.2962 0 15.8874 0C15.4786 0 15.0738 0.0762847 14.6962 0.224498C14.3185 0.372711 13.9753 0.589949 13.6863 0.863808L1.98036 11.9534C1.63204 12.2834 1.37872 12.6929 1.24651 13.1428L0.0218525 17.2863C-0.00644283 17.3824 -0.00727457 17.4838 0.0194429 17.5803C0.0461603 17.6768 0.0994663 17.7647 0.173899 17.8353C0.248331 17.9058 0.341214 17.9563 0.44303 17.9816C0.544846 18.0069 0.651935 18.0061 0.753324 17.9793L5.12632 16.8191C5.60126 16.6932 6.03394 16.4535 6.38265 16.1232L18.0886 5.03356C18.6722 4.48057 19 3.73064 19 2.94869C19 2.16673 18.6722 1.4168 18.0886 0.863808ZM14.5262 1.65876C14.8873 1.31675 15.3771 1.12465 15.8877 1.12472C16.3983 1.12479 16.888 1.31703 17.249 1.65914C17.6101 2.00125 17.8128 2.46521 17.8128 2.94895C17.8127 3.4327 17.6098 3.8966 17.2487 4.23861L16.0295 5.39279L13.3071 2.81294L14.5262 1.65876ZM12.468 3.60865L15.1912 6.18849L5.54273 15.3282C5.33837 15.5218 5.08482 15.6623 4.8065 15.7362L1.44917 16.6264L2.38885 13.4466C2.46693 13.183 2.61522 12.9428 2.8195 12.7491L12.468 3.60865Z"
                                                            fill="#484848" />
                                                    </svg>
                                                </a>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td [attr.colspan]="13" class="text-center">No records found</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>

<p-dialog styleClass="popop" [(visible)]="displayNewSubscriptionDialog" [modal]="true" [baseZIndex]="10000"
    [draggable]="false" [resizable]="false">

    <div class="popop-content delete-popop-content">
        <h3>{{ newSubscription?.SubscriptionId ? 'Edit Subscription' : 'New Subscription' }}</h3>
        <div class="subscription-dialog__content">
            <form class="form" autocomplete="off">
                <div class="form__group">
                    <label class="form__label">Company Name</label>
                    <p-dropdown class="select-dropdown" [options]="customerOptions" optionLabel="label"
                        optionValue="value" [(ngModel)]="newSubscription.CustomerId"
                        [ngModelOptions]="{standalone: true}" [filter]="true"
                        [disabled]="!!newSubscription?.SubscriptionId"
                        (onChange)="onDialogCustomerChange($event.value)"
                        [showClear]="!newSubscription?.SubscriptionId" placeholder="Select"></p-dropdown>
                    <small *ngIf="blockedRanges?.length" style="color:#b45309; display:block; margin-top:6px;">
                        Dates already covered by this company's subscriptions are disabled in the calendars.
                    </small>
                </div>

                <div class="field-pair">
                    <div class="form__group">
                        <label class="form__label">Start Date</label>
                        <p-calendar appendTo="body" [baseZIndex]="11000" [(ngModel)]="startDateValue"
                            [ngModelOptions]="{standalone: true}" [minDate]="startMinDate"
                            [disabledDates]="disabledDates"
                            [disabled]="!newSubscription?.CustomerId" (onSelect)="onStartDateSelect()"
                            panelStyleClass="body-calendar" inputId="subStartDate"
                            class="form__calendar" [showIcon]="true" placeholder="Calendar">
                        </p-calendar>
                    </div>

                    <div class="form__group">
                        <label class="form__label">End Date</label>
                        <p-calendar appendTo="body" [baseZIndex]="11000" [(ngModel)]="endDateValue"
                            [ngModelOptions]="{standalone: true}" [minDate]="endMinDate" [maxDate]="endMaxDate"
                            [disabledDates]="disabledDates"
                            [disabled]="!newSubscription?.CustomerId"
                            panelStyleClass="body-calendar" inputId="subEndDate"
                            class="form__calendar" [showIcon]="true" placeholder="Calendar">
                        </p-calendar>
                    </div>
                </div>

                <div class="form__group">
                    <label class="form__label">Subscription Type</label>
                    <p-dropdown class="select-dropdown" [options]="subscriptionTypeOptions" optionLabel="label"
                        optionValue="value" [(ngModel)]="newSubscription.SubscriptionType"
                        [ngModelOptions]="{standalone: true}" [appendTo]="'body'" [baseZIndex]="11000"
                        placeholder="Select"></p-dropdown>
                </div>

                <div class="form__group">
                    <label class="form__label">Subscription Volume (Pages)</label>
                    <input class="form__control" type="number" [value]="newSubscription.SubscriptionVolume"
                        (input)="newSubscription.SubscriptionVolume = $any($event.target).value" />
                </div>
            </form>
        </div>

        <div class="button-block">
            <button type="button" class="btn-secondary" (click)="closeNewSubscriptionDialog()">Cancel</button>
            <button type="button" class="btn-primary" (click)="createSubscription()">{{ newSubscription?.SubscriptionId ? 'Update Subscription' : 'Create Subscription' }}</button>
        </div>
    </div>
</p-dialog>

<div class="alert" [ngClass]="messageClass ? 'success' : 'warning'" *ngIf="displayMessage">
    <p>{{message}}</p>
    <a class="close-popup" href="javascript:void(0);" (click)="closeMessagePopup()"><img width="20"
            src="assets/img/close-ic.svg"> </a>
</div>

<div class="loader-outer" *ngIf="loading">
    <div class="loader"></div>
</div>